export default function getType(charity) {
  if (charity && charity.charity_type) {
    const charityType = charity.charity_type;

    if (charityType.toUpperCase() === 'PPGF_PPCC') {
      return 'PPGF';
    } else {
      return charityType;
    }
  }
  return 'PPGF';
}
